import React, { useState } from "react";
import "../Assessts/Styles/Teams.scss";
// import { Images } from "../ReUableComponents/CommonElements";
import TBanner from "../Assessts/Images/Teams/TBanner.png";
import { Row, Col } from "react-bootstrap";
import IOText from "../ReUableComponents/ImageOntext";

// import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";

import ST1 from "../Assessts/Images/Teams/ST1.png";
import ST2 from "../Assessts/Images/Teams/ST2.png";
import ST3 from "../Assessts/Images/Teams/ST3.jpeg";
import ST4 from "../Assessts/Images/Teams/ST4.png";
import ST5 from "../Assessts/Images/Teams/ST5.png";

import CLM1 from "../Assessts/Images/Teams/CLM1.png";
import CLM2 from "../Assessts/Images/Teams/CLM2.png";
import CLM3 from "../Assessts/Images/Teams/CLM3.png";
import CLM4 from "../Assessts/Images/Teams/CLM4.png";
import CLM5 from "../Assessts/Images/Teams/CLM5.png";
import CLM6 from "../Assessts/Images/Teams/CLM6.png";
import CLM7 from "../Assessts/Images/Teams/CLM7.png";

import { RiFileExcel2Line } from "react-icons/ri";
import * as XLSX from "xlsx";
const OurBoard = () => {

    const STPeople = [
        { img: ST1, Name: "Mr. Baburao S", Position: "Sr. Manager Scholarships​",Linkedin:"https://www.linkedin.com/in/baburaosattharu?utm_source=share_via&utm_content=profile&utm_medium=member_android" },
        { img: ST2, Name: "Ms. Mamatha R", Position: "Program Associate​ Scholarships ​",Linkedin:"https://www.linkedin.com/in/mamatha-raavi-2b35a1354?utm_source=share_via&utm_content=profile&utm_medium=member_android" },
        { img: ST3, Name: "Mr. Manoj D", Position: "Program Manager - Skill Development & Mentorship​",Linkedin:"https://www.linkedin.com/in/manojkumar-dharamalla-9215951b7?utm_source=share_via&utm_content=profile&utm_medium=member_android" },
        { img: ST4, Name: "Ms. Sangeetha R", Position: "Program Associate Seva​",Linkedin:"https://www.linkedin.com/in/ratlavath-sangeetha-82aa75278?utm_source=share_via&utm_content=profile&utm_medium=member_android" },
        { img: ST5, Name: "Ms. Sravanthi D", Position: "Program Associate Mentorship​",Linkedin:"" },
    ];

    const CLMPeople = [
        { img: CLM1, Name: "Sri Kode Durga Prasad, IPS (Retd)", Position: "Chairman, NSF – India",Linkedin:"" },
        { img: CLM2, Name: "Sri Subhash Chandra Chowdary, IRS (Retd)", Position: "Chairman, NSF – Scholarship",Linkedin:"" },
        { img: CLM3, Name: "Sri V V Prasad Chowdary Chitturi", Position: "Member, Scholarship Committee",Linkedin:"" },
        { img: CLM4, Name: "Sri Dr. Chalasani Rao", Position: "Managing Trustee",Linkedin:"" },
        { img: CLM5, Name: "Sri Kanneganti Sudhakar", Position: "Chief Coordinator",Linkedin:"" },
        { img: CLM6, Name: "Sri B Srinivas Rao, IPS (Retd)", Position: "National Coordinator",Linkedin:"" },
        { img: CLM7, Name: "Sri V Harsha Vardhan", Position: "National Coordinator​",Linkedin:"" },
    ];

    const Pagedata = [
        { Data: CLMPeople, Tittle: "Committee / Leadership Members", color: "#EFFFFB" },
        {Data:[],Tittle: "Chapter Coordinators", color: "#F6F2ED",Content:true},
        { Data: STPeople, Tittle: "Scholarship Team", color: "#fff" },
    ];
//  const [htmlContent, setHtmlContent] = useState("");

//   const handleOpen = async () => {
//     try {
//       const response = await fetch("/Chapter Coordinators.xlsx");
//       const data = await response.arrayBuffer();

//       const workbook = XLSX.read(data, { type: "array" });
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//       const html = XLSX.utils.sheet_to_html(sheet);

//       setHtmlContent(html); // ✅ React way
//     } catch (error) {
//       console.error("Error loading file:", error);
//     }
//   };
  const handleOpen = async () => {
    try {
      const response = await fetch("/Chapter Coordinators.xlsx");
      const data = await response.arrayBuffer();

      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const html = XLSX.utils.sheet_to_html(sheet);

      // 🔥 Open new tab
      const newWindow = window.open("", "_blank");

      newWindow.document.write(`
        <html>
          <head>
            <title>Excel Preview</title>
            <style>
              body { font-family: Arial; padding: 20px; }
              table { border-collapse: collapse; width: 100%; }
              td, th { border: 1px solid #ccc; padding: 8px; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            ${html}
          </body>
        </html>
      `);

      newWindow.document.close();

    } catch (error) {
      console.error("Error loading file:", error);
    }
  };
    return (
        <>
            <div className="Single_Banner mt-2">
                <IOText Image={TBanner} Alt="Teams" Text={<div className="Text-MainDiv w-100" >
                    <div >An Experienced <span style={{ color: "#F7D670" }}>Team Managing</span> Scholarship <span style={{ color: "#F7D670" }}>Programs with Integrity.</span>
                    </div>
                </div>} /></div>
            <div className="Scholaeship-Teams">

                {Pagedata.map((Team) => (
                    <>
                        <div
                            className="container-fluid pb-4"
                            style={{ backgroundColor: `${Team?.color}` }}
                        >
                            <div className="Web-MainHeading pt-4 pb-4">{Team.Tittle}</div>
                         {Team.Content ? <div className="dflex flexd-column alignitems" style={{textAlign:"center"}}>
                         <p>Click on the icon below to see the Names and Contact details of the Chapter Coordinators </p>
                         <button className="Website-Buttons mt-3" style={{backgroundColor:"#347462"}}
                         onClick={()=> window.open("/Chapter Coordinators.xlsx", "_blank")}
                        //  handleOpen()   
                         >Chapter Coordinators <RiFileExcel2Line/></button>
                         </div> :    <Row>
                                {Team.Data.map((item) => (
                                    <Col className="dflex  flexd-column alignitems Team-each" style={{ textAlign: "center", justifyContent: "flex-start" }}>
                                        <span> <img src={item.img} alt={item.Name} />
                                            <div>
                                                {/* <p> <FaXTwitter /></p>  */}
                                                <p> <FaLinkedinIn onClick={()=> item.Linkedin && window.open(item.Linkedin, "_blank")}/></p>
                                            </div>
                                        </span>
                                        <div className="Web-SubHeading" >{item.Name}</div>
                                        <p >{item.Position}</p>
                                    </Col>
                                ))}
                            </Row>}
                        </div>
                    </>
                ))}

            </div>

                  {/* <div
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      /> */}

        </>
    );
};
export default OurBoard;